import request from './request'

export function getCurtainCustomerId() {
  return request({
    url: '/api/Curtain/GetCurtainCustomerId',
    method: 'get'
})
}


// WEBPACK FOOTER //
// ./src/api/GetCurtainCustomerId.js